import { useContext } from "react";
import { useLocation, useResolvedPath } from "react-router-dom";
import { SessaoContext } from "../Contexts/SessaoContext";
import { Permissoes } from "../Constants/Permissoes";

/**
 * 
 */
export const useRequerPermissoes = () => {
    const permissoes = useContext(SessaoContext)?.sessao?.usuario?.permissoes.map((p) => p.nome);

    return {
        todas: (...params: string[] ) => {
            if(permissoes == undefined) return false;
            return params.every((p) => permissoes.includes(p))
        },
        alguma: (...params: string[]) => {
            if(permissoes == undefined) return false;
            return params.some((p) => permissoes.includes(p))
        }
    }
}